import script from "./SalaryReport.vue?vue&type=script&setup=true&lang=js"
export * from "./SalaryReport.vue?vue&type=script&setup=true&lang=js"

import "./SalaryReport.vue?vue&type=style&index=0&id=5aa96200&lang=scss"
import "./SalaryReport.vue?vue&type=style&index=1&id=5aa96200&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa96200"]])

export default __exports__